module.exports = __webpack_public_path__ + "img/Copyright_pic02.0a6d0284.jpg";